import { render, staticRenderFns } from "./WrapperFormControl.vue?vue&type=template&id=56f1d784&"
import script from "./WrapperFormControl.vue?vue&type=script&lang=js&"
export * from "./WrapperFormControl.vue?vue&type=script&lang=js&"
import style0 from "./WrapperFormControl.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports